import { createTheme, ThemeProvider, responsiveFontSizes } from "@mui/material/styles"
import { CssBaseline } from "@mui/material"
import { HashRouter as Router, Route, Routes } from "react-router-dom"

import "../../resources/fonts/fonts.css"
import Navigation from "./Navigation"
import Footer from "./Footer"
import HomePage from "./HomePage"
import BenNevis from "../building100/BenNevis"
import Everest from "../building100/Everest"
import K2 from "../building120/K2"
import TheExcellenceRoom from "../building120/TheExcellenceRoom"
import MountMarcy from "../building120/MountMarcy"
import MatterHorn from "../building170/MatterHorn"
import MontBlanc from "../building170/MontBlanc"
import PikesPeak from "../building170/PikesPeak"
import TrainingRoom from "../building170/TrainingRoom"
import Chasseral from "../buildingPCH/Chasseral"
import SubmittedForm from "../parts/SubmittedForm"

function App() {
    let palette = {
        primary: { main: "#717073" },
        secondary: { main: "#DF7A00" }
    }

    const background = { default: "#fafafa", paper: "#ffffff", appBar: "#ffffff" }

    let theme = createTheme({
        palette: {
            ...palette,
            background, 
        },
        typography: {
            fontFamily: "Century",
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        backgroundColor: background.default, 
                        overflowX: 'hidden',
                        margin: 0,
                        padding: 0,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundColor: background.paper,
                        backgroundImage: "none",
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: background.appBar,
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        fontSize: '14px', 
                    },
                    textarea: {
                        fontSize: '14px', 
                    },
                },
            },
            MuiSwitch: {
                styleOverrides: {
                    switchBase: {
                        '&.Mui-checked': {
                            color: '#DF7A00', 
                            '& + .MuiSwitch-track': {
                                backgroundColor: '#DF7A00', 
                            },
                        },
                    },
                },
            },
        },
    });

    const ComponentPage = (page) => {
        return (
            <>
                <Navigation />
                <main style={{ height: "97.5vh" }}>{page}</main>
                <Footer />
            </>
        )
    }

    return (
        <ThemeProvider theme={responsiveFontSizes(theme)}>
            <Router>
                <CssBaseline />
                <Routes>
                    <Route path="/" exact element={ComponentPage(<HomePage />)} />
                    <Route path="/ben-nevis" exact element={ComponentPage(<BenNevis />)} />
                    <Route path="/everest" exact element={ComponentPage(<Everest />)} />
                    <Route path="/k2" exact element={ComponentPage(<K2 />)} />
                    <Route path="/the-excellence-room" exact element={ComponentPage(<TheExcellenceRoom />)} />
                    <Route path="/mount-marcy" exact element={ComponentPage(<MountMarcy />)} />
                    <Route path="/matterhorn" exact element={ComponentPage(<MatterHorn />)} />
                    <Route path="/mont-blanc" exact element={ComponentPage(<MontBlanc />)} />
                    <Route path="/pikes-peak" exact element={ComponentPage(<PikesPeak />)} />
                    <Route path="/training-room" exact element={ComponentPage(<TrainingRoom />)} />
                    <Route path="/chasseral" exact element={ComponentPage(<Chasseral />)} />
                    <Route path="/success" exact element={ComponentPage(<SubmittedForm />)} />
                </Routes>
            </Router>
        </ThemeProvider>
    )
}

export default App
